<template>
  <div>
    <div v-if="clickable">
      <v-menu
      v-model="showMenu"
      absolute
      offset-y
      :close-on-content-click="false"
      :min-width="300"
    >
      <template v-slot:activator="{ on }">
        <v-avatar 
          v-bind="$attrs"
          
          v-on="on"
          style="cursor: pointer"
          flat
        >
          <img
            v-if="url && !status.loading"
            :src="url" style="max-width:100%" v-bind="image"
          />

          <slot
            v-if="!url && !status.loading"
            name="none"
          >
            <v-icon large v-text="icon"></v-icon>
          </slot>

          <slot
            v-if="status.loading"
            name="loading"
            :status="status"
          >
            <v-progress-circular
              :value="status.progress"
              :size="32"
              :width="2"
              color="primary"
            />
          </slot>
        </v-avatar>
      </template>
      <v-list class="pt-0">
        <v-toolbar flat dense>{{title}}</v-toolbar>
        <v-divider></v-divider>
        <v-list-item v-if="!showUrl"
         @click="click"
        >
          <v-list-item-icon class="mr-2"><v-icon>mdi-briefcase-upload-outline</v-icon></v-list-item-icon>
          <v-list-item-title>Afbeelding uploaden</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="!showUrl"
         @click="showUrl=true"
        >
          <v-list-item-icon class="mr-2"><v-icon>mdi-link-variant-plus</v-icon></v-list-item-icon>
          <v-list-item-title>Link invoeren of plakken</v-list-item-title>
        </v-list-item>
      <v-list-item v-else>
          <v-text-field v-model="url" autofocus placeholder="Link invoeren of plakken"></v-text-field>
      </v-list-item>
       </v-list>
       <v-toolbar v-if="showUrl" dense flat>
          <v-btn text @click="showUrl=false">cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="changed">Opslaan</v-btn>
       </v-toolbar>
      </v-menu>

      <input
        type="file"
        ref="file"
        name="file"
        @change="select($event.target.name, $event.target.files)"
        style="display: none"
      />
    </div>

    <div v-else>
      <v-avatar
       v-bind="$attrs">
        <img
          v-if="url"
          :src="url"
           v-bind="image"
        />

        <slot
          v-else
          name="none"
        >
          <v-icon large v-text="icon"></v-icon>
        </slot>
      </v-avatar>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'

export default {
  props: {
    value: {
      type: String
    },
     title: {
      type: String,
      default:"Afbeelding"
    },
    rename: {
      type: Function,
      required: false,
      default: file => file.name
    },
    type: {
      type: String,
      required: false,
      default: 'avatar'
    },
    field: {
      type: String,
      required: false,
      default: 'file'
    },
    clickable: {
      type: Boolean,
      required: false,
      default: true
    },

    maxSize: {
      type: Number,
      required: false,
      default: 2048
    },
    
    headers: {
      type: Object,
      required: false,
      default: () => ({})
    },
    image: {
      type: Object,
      required: false,
      default: () => ({})
    },
    icon: {
      type: String,
      required: false,
      default: 'account_circle'
    },
  },

  data: () => ({
    showMenu:false,
    showUrl: false,
    status: {
      loading: false,
      progress: 0
    }
  }),
  computed:{
    
    url: {
      get(){
        return this.value
      },
      set(value){
        return this.$emit('input',value)
      }
    },
    api(){
      let api = this.$config.api
      if (this.$store.state.modus == 'test') api = this.$config.testapi
      return api
    }
  },
  watch: {
    showMenu(value){
      this.showUrl = false
    }
  },
  methods: {
    changed(){
      this.showMenu = false
      this.showUrl = false
      this.$emit('success', this.url)
    },
    click () {
      this.showMenu = false
      if (!this.status.loading) {
        if (!this.url) {
          this.choose()
        } else {
          this.replace()
        }
      } else {
        this.$emit('cancel')
      }
    },

    choose () {
      return this.$refs.file.click()
    },

    replace () {
      if (this.$listeners.replace) {
        this.$emit('replace')
      } else {
        this.choose()
      }
    },

    select (field, file) {
      const [ image ] = file
      const { maxSize } = this

      if (file.length > 0) {
        const size = image.size / 1024

        if (!image.type.match('image.*')) {
          this.$emit('error-type')
        } else if (size > maxSize) {
          this.$emit('error-size')
        } else {
          this.upload(image)
        }
      } else {
        this.$emit('error-empty')
      }
    },
    async request (form, config) {
      
      const axios = Axios.create({
        baseURL: this.api.url || process.env.baseUrl
      })
      return await axios.post('/api/io/upload/' + this.type, form, config)
    },
    async upload (file) {
      this.status.loading = true

      const form = new FormData()

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          "x-api-key": this.api.key,
          "Authorization": this.$token,
          ...this.headers
        },

        onUploadProgress: function (event) {
          if (event.lengthComputable) {
            const progress = (event.loaded / event.total) * 100

            this.status.progress = progress

            this.$emit('progress', progress)
          }
        }.bind(this)
      }

      form.append(this.field, file, this.rename(file))

      try {
        const upload = await this.request(form, config)
        this.url = upload.data.location
        this.$emit('success', upload)
      } catch (e) {
        this.$emit('failed', e)
      } finally {
        this.status.loading = false
        this.status.progress = 0
      }
    }
  }
}
</script>
